import {
    BUSINESS_ORGANISATION_LIST_REQUEST,
    BUSINESS_ORGANISATION_LIST_SUCCESS,
    BUSINESS_ORGANISATION_LIST_FAIL,
    BUSINESS_ORGANISATION_DETAILS_REQUEST,
    BUSINESS_ORGANISATION_DETAILS_SUCCESS,
    BUSINESS_ORGANISATION_DETAILS_FAIL,
    BUSINESS_ORGANISATION_DETAILS_RESET,
    BUSINESS_ORGANISATION_CREATE_REQUEST,
    BUSINESS_ORGANISATION_CREATE_SUCCESS,
    BUSINESS_ORGANISATION_CREATE_FAIL,
    BUSINESS_ORGANISATION_CREATE_RESET,
    BUSINESS_ORGANISATION_UPDATE_REQUEST,
    BUSINESS_ORGANISATION_UPDATE_SUCCESS,
    BUSINESS_ORGANISATION_UPDATE_FAIL,
    BUSINESS_ORGANISATION_UPDATE_RESET,
    BUSINESS_ORGANISATION_DELETE_REQUEST,
    BUSINESS_ORGANISATION_DELETE_SUCCESS,
    BUSINESS_ORGANISATION_DELETE_FAIL,
    BUSINESS_ORGANISATION_DTO_REQUEST,
    BUSINESS_ORGANISATION_DTO_SUCCESS,
    BUSINESS_ORGANISATION_DTO_FAIL,
    BUSINESS_ORGANISATION_DTO_RESET,
    BUSINESS_ORGANISATION_LIST_BYIDS_REQUEST,
    BUSINESS_ORGANISATION_LIST_BYIDS_SUCCESS,
    BUSINESS_ORGANISATION_LIST_BYIDS_FAIL,
    BUSINESS_ORGANISATION_LIST_BYIDS_RESET,
    BUSINESS_ORGANISATION_ACTIVATE_REQUEST,
    BUSINESS_ORGANISATION_ACTIVATE_SUCCESS,
    BUSINESS_ORGANISATION_ACTIVATE_FAIL,
    BUSINESS_ORGANISATION_ACTIVATE_RESET,
    BUSINESS_ORGANISATION_DEACTIVATE_REQUEST,
    BUSINESS_ORGANISATION_DEACTIVATE_SUCCESS,
    BUSINESS_ORGANISATION_DEACTIVATE_FAIL,
    BUSINESS_ORGANISATION_DEACTIVATE_RESET,
    BUSINESS_ORGANISATION_AGREEMENT_UPDATE_REQUEST,
    BUSINESS_ORGANISATION_AGREEMENT_UPDATE_SUCCESS,
    BUSINESS_ORGANISATION_AGREEMENT_UPDATE_FAIL,
    BUSINESS_ORGANISATION_AGREEMENT_UPDATE_RESET,
    SEND_EMAIL_REQUEST,
    SEND_EMAIL_SUCCESS,
    SEND_EMAIL_FAIL,
    SEND_EMAIL_RESET,
} from '../constants/businessOrganisationConstants';

export const businessOrganisationListReducer = (
    state = { businessOrganisations: [], currentPage: 1, totalPages: 1, totalCount: 0 },
    action
) => {
    const normalizePaginatedPayload = (payload = {}) => {
        const source = payload?.data ?? payload ?? {};
        const businessOrganisations = source.items ?? [];
        const currentPage = source.currentPage ?? 1;
        const totalPages = source.totalPages ?? 1;
        const totalCount = source.totalCount ?? businessOrganisations.length;

        return { businessOrganisations, currentPage, totalPages, totalCount };
    };

    switch (action.type) {
        case BUSINESS_ORGANISATION_LIST_REQUEST:
            return { ...state, loading: true, error: null };
        case BUSINESS_ORGANISATION_LIST_SUCCESS: {
            const { businessOrganisations, currentPage, totalPages, totalCount } = normalizePaginatedPayload(action.payload);
            return {
                loading: false,
                businessOrganisations,
                currentPage,
                totalPages,
                totalCount,
                error: null,
            };
        }
        case BUSINESS_ORGANISATION_LIST_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export const businessOrganisationListByIdsReducer = (state = { businessOrganisations: [] }, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_LIST_BYIDS_REQUEST:
            return { loading: true, businessOrganisations: [] };
        case BUSINESS_ORGANISATION_LIST_BYIDS_SUCCESS:
            return { loading: false, businessOrganisations: action.payload,
            };
        case BUSINESS_ORGANISATION_LIST_BYIDS_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_LIST_BYIDS_RESET:
            return { businessOrganisations: [] };
        default:
            return state;
    }
};

export const businessOrganisationDetailsReducer = (state = { businessOrganisation: {} }, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_DETAILS_REQUEST:
            return { loading: true, ...state };
        case BUSINESS_ORGANISATION_DETAILS_SUCCESS:
            return { loading: false, businessOrganisation: action.payload };
        case BUSINESS_ORGANISATION_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_DETAILS_RESET:
            return { businessOrganisation: {} };
        default:
            return state;
    }
};

export const businessOrganisationDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_DELETE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_DELETE_SUCCESS:
            return { loading: false, success: true };
        case BUSINESS_ORGANISATION_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const businessOrganisationCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_CREATE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_CREATE_SUCCESS:
            return { loading: false, success: true, businessOrganisation: action.payload };
        case BUSINESS_ORGANISATION_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const businessOrganisationUpdateReducer = (state = { businessOrganisation: {} }, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_UPDATE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_UPDATE_SUCCESS:
            return { loading: false, success: true, businessOrganisation: action.payload };
        case BUSINESS_ORGANISATION_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_UPDATE_RESET:
            return { businessOrganisation: {} };
        default:
            return state;
    }
};

export const businessOrganisationDtoReducer = (state = { businessOrganisationDto: {} }, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_DTO_REQUEST:
            return { loading: true, businessOrganisationDto: {} };
        case BUSINESS_ORGANISATION_DTO_SUCCESS:
            return { loading: false, businessOrganisationDto: action.payload };
        case BUSINESS_ORGANISATION_DTO_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_DTO_RESET:
            return { businessOrganisationDto: {} };
        default:
            return state;
    }
};

export const businessOrganisationActivateReducer = (state = {}, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_ACTIVATE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_ACTIVATE_SUCCESS:
            return { loading: false, success: true };
        case BUSINESS_ORGANISATION_ACTIVATE_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_ACTIVATE_RESET:
            return {};
        default:
            return state;
    }
};

export const businessOrganisationDeactivateReducer = (state = {}, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_DEACTIVATE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_DEACTIVATE_SUCCESS:
            return { loading: false, success: true };
        case BUSINESS_ORGANISATION_DEACTIVATE_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_DEACTIVATE_RESET:
            return {};
        default:
            return state;
    }
};

export const businessOrganisationAgreementUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case BUSINESS_ORGANISATION_AGREEMENT_UPDATE_REQUEST:
            return { loading: true };
        case BUSINESS_ORGANISATION_AGREEMENT_UPDATE_SUCCESS:
            return { loading: false, success: true, businessOrganisation: action.payload };
        case BUSINESS_ORGANISATION_AGREEMENT_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case BUSINESS_ORGANISATION_AGREEMENT_UPDATE_RESET:
            return {};
        default:
            return state;
    }
};

export const sendEmailReducer = (state = {}, action) => {
    switch (action.type) {
        case SEND_EMAIL_REQUEST:
            return { loading: true };
        case SEND_EMAIL_SUCCESS:
            return { loading: false, success: true };
        case SEND_EMAIL_FAIL:
            return { loading: false, error: action.payload };
        case SEND_EMAIL_RESET:
            return {};
        default:
            return state;
    }
}; 